import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useForm } from './useForm';
import { useEffect, useState } from 'react';

export default function AutocompleteResponsable(proyectoPlanRecibido, isEditing) {

  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);

  const { proyectoPlan } = useForm(proyectoPlanRecibido)

  useEffect(() => {
    (async () => {
      
      const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/academicos/${sessionStorage.getItem('idEntidad')}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })
      const responsables = await res.json()

      setOptions([...responsables]);

      if (proyectoPlanRecibido.idResponsable) {
        const usuarioSeleccionado = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/usuarios/select/${proyectoPlanRecibido.idResponsable}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": sessionStorage.getItem('token'),
            "perfil": sessionStorage.getItem('perfil')
          }
        })
        const usuarioSet = await usuarioSeleccionado.json()
        setValue(usuarioSet);
      }
      else {
        setValue(null)
      }
    })();
  }, [proyectoPlanRecibido.idResponsable]);



  return (
    <Autocomplete
      id="responsable"
      sx={{ width: 300 }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.id + '-' + option.nombre + ' ' + option.apellidoPaterno + ' ' + option.apellidoMaterno}
      options={options}
      value={value}
      onChange={async (event, newValue) => {
        setValue(newValue);
        //console.log(`newValue ${JSON.stringify(newValue)}`)
      }}
      renderInput={(params) => (
        <TextField name='responsable' required
          value={proyectoPlan.responsable} 
          {...params}
          focused variant='outlined'
          label="Número económico del responsable"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      renderOption={(props, option, { inputValue }) => {
        const matches = match(option.id + '-' + option.nombre + ' ' + option.apellidoPaterno + ' ' + option.apellidoMaterno, inputValue);
        const parts = parse(option.id + '-' + option.nombre + ' ' + option.apellidoPaterno + ' ' + option.apellidoMaterno, matches);

        return (
          <li {...props}>
            <div>
              {parts.map((part, index) => (
                <span
                  key={index}
                  style={{
                    fontWeight: part.highlight ? 700 : 400,
                  }}
                >
                  {part.text}
                </span>
              ))}
            </div>
          </li>
        );
      }}
    />
  );
}
